export default "__VITE_ASSET__ed058ed8__"